/* eslint-disable max-lines */

import {
  removeExcludedInsight,
  removeExcludedPrevent,
  removeExcludedRoles,
  removeExcludedTeams,
  removeIncludedInsight,
  removeIncludedPrevent,
  removeIncludedRoles,
  removeIncludedTeams,
} from 'actions/userPermissionsPage';
import { MultiSelectOption } from 'components/MultiSelectDropdown/MultiSelectDropdownRedesign';
import Labels from 'components/UsersPermissions/UserPermissionsForm/Labels';
import useAllTeams from 'hooks/teams/useAllTeams';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import { getUser } from 'selectors/auth';
import {
  getExcludedInsight,
  getExcludedPrevent,
  getExcludedRoles,
  getExcludedTeams,
  getIncludedInsight,
  getIncludedPrevent,
  getIncludedRoles,
  getIncludedTeams,
} from 'selectors/userPermissionsPage';
import 'styles/labelsStyle.css';
import userTypeMap from 'utils/usersListMap';

const PermissionsLabels: React.FC = () => {
  const dispatch = useDispatch();
  const route = useRouteMatch();

  const { data } = useAllTeams();
  const user = useSelector(getUser);
  const isSuperAdmin = user.roles.includes('super-admin');

  const includedTR = useSelector(getIncludedTeams);
  const excludedTR = useSelector(getExcludedTeams);

  const userTypeName = Object.entries(userTypeMap).find(
    ([k]) => route.path.split('/').pop() === k
  )?.[0];

  // @ts-ignore
  const includedTeams = includedTR.filter((t) => t.kind === 'division');
  // @ts-ignore
  const excludedTeams = excludedTR.filter((t) => t.kind === 'division');

  // @ts-ignore
  const includedRegions = includedTR.filter((t) => t.kind === 'region');
  // @ts-ignore
  const excludedRegions = excludedTR.filter((t) => t.kind === 'region');

  // @ts-ignore
  const includedManagementLevels = includedTR.filter((t) => t.kind === 'management-level');
  // @ts-ignore
  const excludedManagementLevels = excludedTR.filter((t) => t.kind === 'management-level');

  const includedRoles = useSelector(getIncludedRoles);
  const excludedRoles = useSelector(getExcludedRoles);

  const includedInsight = useSelector(getIncludedInsight);
  const excludedInsight = useSelector(getExcludedInsight);

  const includedPrevent = useSelector(getIncludedPrevent);
  const excludedPrevent = useSelector(getExcludedPrevent);

  const handleDeleteTeam = (option: MultiSelectOption): void => {
    const team = data?.records.find((t) => t.uuid === option.value);

    if (team) {
      dispatch(removeIncludedTeams([team]));
      dispatch(removeExcludedTeams([team]));
    }
  };

  const handleDeleteRole = (option: MultiSelectOption): void => {
    dispatch(removeIncludedRoles([option.value]));
    dispatch(removeExcludedRoles([option.value]));
  };

  const handleDeleteInsight = (option: MultiSelectOption): void => {
    dispatch(removeIncludedInsight([option.value]));
    dispatch(removeExcludedInsight([option.value]));
  };

  const handleDeletePrevent = (option: MultiSelectOption): void => {
    dispatch(removeIncludedPrevent([option.value]));
    dispatch(removeExcludedPrevent([option.value]));
  };

  const monitoredLabels = (
    <div className="flex flex-col gap-2">
      {(includedTeams.length > 0 || excludedTeams.length > 0) && (
        <div className="flex flex-col gap-1">
          <span className="font-bold">Division</span>
          <div className="pl-3">
            <Labels
              includedLabels={includedTeams.map((t) => ({ value: t.uuid, label: t.name }))}
              excludedLabels={excludedTeams.map((t) => ({ value: t.uuid, label: t.name })) || []}
              handleDelete={handleDeleteTeam}
            />
          </div>
        </div>
      )}
      {(includedRegions.length > 0 || excludedRegions.length > 0) && (
        <div className="flex flex-col gap-1">
          <span className="font-bold">Region</span>
          <div className="pl-3">
            <Labels
              includedLabels={includedRegions.map((t) => ({ value: t.uuid, label: t.name }))}
              excludedLabels={excludedRegions.map((t) => ({ value: t.uuid, label: t.name })) || []}
              handleDelete={handleDeleteTeam}
            />
          </div>
        </div>
      )}
      {(includedManagementLevels.length > 0 || excludedManagementLevels.length > 0) && (
        <div className="flex flex-col gap-1">
          <span className="font-bold">Management Level</span>
          <div className="pl-3">
            <Labels
              includedLabels={includedManagementLevels.map((t) => ({
                value: t.uuid,
                label: t.name,
              }))}
              excludedLabels={
                excludedManagementLevels.map((t) => ({ value: t.uuid, label: t.name })) || []
              }
              handleDelete={handleDeleteTeam}
            />
          </div>
        </div>
      )}
    </div>
  );

  const LLLabels = (
    <div className="flex flex-col gap-2">
      {(includedRoles.length > 0 || excludedRoles.length > 0) && (
        <div className="flex flex-col gap-1">
          <span className="font-bold">Role</span>
          <div className="pl-3">
            <Labels
              includedLabels={includedRoles.map((r) => ({ value: r, label: r }))}
              excludedLabels={excludedRoles.map((r) => ({ value: r, label: r })) || []}
              handleDelete={handleDeleteRole}
            />
          </div>
        </div>
      )}
      {(includedTeams.length > 0 || excludedTeams.length > 0) && (
        <div className="flex flex-col gap-1">
          <span className="font-bold">Division</span>
          <div className="pl-3">
            <Labels
              includedLabels={includedTeams.map((t) => ({ value: t.uuid, label: t.name }))}
              excludedLabels={excludedTeams.map((t) => ({ value: t.uuid, label: t.name })) || []}
              handleDelete={handleDeleteTeam}
            />
          </div>
        </div>
      )}
      {(includedRegions.length > 0 || excludedRegions.length > 0) && (
        <div className="flex flex-col gap-1">
          <span className="font-bold">Region</span>
          <div className="pl-3">
            <Labels
              includedLabels={includedRegions.map((t) => ({ value: t.uuid, label: t.name }))}
              excludedLabels={excludedRegions.map((t) => ({ value: t.uuid, label: t.name })) || []}
              handleDelete={handleDeleteTeam}
            />
          </div>
        </div>
      )}
    </div>
  );

  const allLabels = (
    <div className="flex flex-col gap-2">
      {(includedRoles.length > 0 || excludedRoles.length > 0) && (
        <div className="flex flex-col gap-1">
          <span className="font-bold">Role</span>
          <div className="pl-3">
            <Labels
              includedLabels={includedRoles.map((r) => ({ value: r, label: r }))}
              excludedLabels={excludedRoles.map((r) => ({ value: r, label: r })) || []}
              handleDelete={handleDeleteRole}
            />
          </div>
        </div>
      )}
      {(includedTeams.length > 0 || excludedTeams.length > 0) && (
        <div className="flex flex-col gap-1">
          <span className="font-bold">Division</span>
          <div className="pl-3">
            <Labels
              includedLabels={includedTeams.map((t) => ({ value: t.uuid, label: t.name }))}
              excludedLabels={excludedTeams.map((t) => ({ value: t.uuid, label: t.name })) || []}
              handleDelete={handleDeleteTeam}
            />
          </div>
        </div>
      )}
      {(includedRegions.length > 0 || excludedRegions.length > 0) && (
        <div className="flex flex-col gap-1">
          <span className="font-bold">Region</span>
          <div className="pl-3">
            <Labels
              includedLabels={includedRegions.map((t) => ({ value: t.uuid, label: t.name }))}
              excludedLabels={excludedRegions.map((t) => ({ value: t.uuid, label: t.name })) || []}
              handleDelete={handleDeleteTeam}
            />
          </div>
        </div>
      )}
      {(includedManagementLevels.length > 0 || excludedManagementLevels.length > 0) && (
        <div className="flex flex-col gap-1">
          <span className="font-bold">Management Level</span>
          <div className="pl-3">
            <Labels
              includedLabels={includedManagementLevels.map((t) => ({
                value: t.uuid,
                label: t.name,
              }))}
              excludedLabels={
                excludedManagementLevels.map((t) => ({ value: t.uuid, label: t.name })) || []
              }
              handleDelete={handleDeleteTeam}
            />
          </div>
        </div>
      )}
      {(includedInsight.length > 0 || excludedInsight.length > 0) && (
        <div className="flex flex-col gap-1">
          <span className="font-bold">Insight Integrations</span>
          <div className="pl-3">
            <Labels
              includedLabels={includedInsight.map((i) => ({ value: i, label: i }))}
              excludedLabels={excludedInsight.map((i) => ({ value: i, label: i })) || []}
              handleDelete={handleDeleteInsight}
              disabled={!isSuperAdmin}
            />
          </div>
        </div>
      )}
      {(includedPrevent.length > 0 || excludedPrevent.length > 0) && (
        <div className="flex flex-col gap-1">
          <span className="font-bold">Prevent Integrations</span>
          <div className="pl-3">
            <Labels
              includedLabels={includedPrevent.map((p) => ({ value: p, label: p }))}
              excludedLabels={excludedPrevent.map((p) => ({ value: p, label: p })) || []}
              handleDelete={handleDeletePrevent}
              disabled={!isSuperAdmin}
            />
          </div>
        </div>
      )}
    </div>
  );

  return (
    <>
      {userTypeName === 'monitored-users' && monitoredLabels}
      {userTypeName === 'll-users' && LLLabels}
      {!userTypeName && allLabels}
    </>
  );
};

export default PermissionsLabels;
